// Lane F copy (10/15/26): drafted by Astra (copy lane, gpt-6-astra, 10/15), gated by Claude 10/15: every key present,
// placeholders kept, sentence case, no dashes / exclamation marks / jargon, "activities" not "listings". Do not edit by hand:
// a line that needs to change goes back to Astra. Its own file so the lane merges cleanly with the other copy files.
export const LF = {
  // B-158: the link at the bottom of an activity's detail, in plain words (never a data-source name like "Overture Maps")
  'lf.link_own_site': 'Visit {site}',
  'lf.link_listing_site': 'View on {source}',
  'lf.link_map': 'View on map',
  'lf.found_on_map': 'Found on a public map of places, not reviews.',
  'lf.no_link': 'No link available',
  // B-155: More / Less like this stay selected; screen readers hear how to take it back
  'lf.more_hint': 'Selected. Tap again to undo.',
  // R-101: the check-in square takes a drag as well as a tap
  'lf.pad_hint': 'Tap or drag the dot to answer both questions.',
  'lf.pad_adjust': 'Drag or tap to move the dot.',
} as const

export type LfKey = keyof typeof LF
/** A lane F line, with {placeholders} filled. */
export const lf = (k: LfKey, vars: Record<string, string | number> = {}): string =>
  LF[k].replace(/\{(\w+)\}/g, (m, name: string) => (name in vars ? String(vars[name]) : m))
